import { render, staticRenderFns } from "./Hours.vue?vue&type=template&id=282e2157&lang=pug"
import script from "./Hours.vue?vue&type=script&lang=js"
export * from "./Hours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports